import { useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import confetti from "canvas-confetti";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const POLL_INTERVAL_MS = 20000;
const AMBASSADOR_THRESHOLD = 5;
export const AMBASSADOR_UNLOCKED_EVENT = "rr-ambassador-unlocked";

// Watches the current browser's own referral code (set on successful pre-registration)
// and celebrates with confetti + a toast the moment a new referral comes in, as long
// as this tab/session stays open. No email/notification system needed for this MVP.
export const ReferralWinWatcher = () => {
  useEffect(() => {
    const checkForNewReferral = () => {
      const referralCode = localStorage.getItem("rr_referral_code");
      if (!referralCode) return;

      axios
        .get(`${API}/leads/referral/${referralCode}`)
        .then((res) => {
          const count = res.data?.referral_count ?? 0;
          const lastSeen = Number(localStorage.getItem("rr_referral_count_seen") || 0);
          if (count > lastSeen) {
            localStorage.setItem("rr_referral_count_seen", String(count));
            confetti({ particleCount: 100, spread: 80, origin: { y: 0.7 }, colors: ["#F2761E", "#0E2A47", "#FFFFFF"] });
            toast.success(
              count === 1
                ? "🎉 Someone just joined RelayRigs using your referral link!"
                : `🎉 Someone just joined using your referral link! You now have ${count} referrals.`,
              { duration: 6000 }
            );

            if (lastSeen < AMBASSADOR_THRESHOLD && count >= AMBASSADOR_THRESHOLD && !localStorage.getItem("rr_ambassador_unlocked")) {
              localStorage.setItem("rr_ambassador_unlocked", "true");
              window.dispatchEvent(new CustomEvent(AMBASSADOR_UNLOCKED_EVENT));
              setTimeout(() => {
                confetti({ particleCount: 220, spread: 110, origin: { y: 0.6 }, colors: ["#F2761E", "#0E2A47", "#FFFFFF"] });
                toast.success("🏆 You've unlocked Top 10 Founding Ambassador status! 5+ referrals and counting.", { duration: 8000 });
              }, 600);
            } else if (count < AMBASSADOR_THRESHOLD && count >= 3 && lastSeen < count && !localStorage.getItem(`rr_nudge_shown_${count}`)) {
              localStorage.setItem(`rr_nudge_shown_${count}`, "true");
              const remaining = AMBASSADOR_THRESHOLD - count;
              setTimeout(() => {
                toast(`✨ You're so close! ${remaining} more referral${remaining === 1 ? "" : "s"} to unlock Top 10 Founding Ambassador status.`, { duration: 6000 });
              }, 600);
            }
          }
        })
        .catch(() => {});
    };

    const interval = setInterval(checkForNewReferral, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return null;
};
